exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host .obligatoire-hint{text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/depot-requete/steps/requete/requete.component.scss
// module id = 685
// module chunks = 0